import { render, staticRenderFns } from "./RightCornerButtons.vue?vue&type=template&id=d75f6f00&scoped=true"
import script from "./RightCornerButtons.vue?vue&type=script&lang=js"
export * from "./RightCornerButtons.vue?vue&type=script&lang=js"
import style0 from "./RightCornerButtons.vue?vue&type=style&index=0&id=d75f6f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75f6f00",
  null
  
)

export default component.exports